import { HeaderNavItem } from '@/components/nav/header';
import { Flex } from '@mantine/core';
import { IconBell, IconStar, IconTrophy, IconUser, IconWallet } from '@tabler/icons-react';
import { TopNavFor } from './constants';
import styles from './styles.module.css';

interface Props {
	forPage: TopNavFor;
}

export const TopNav = (props: Props) => {
	const { forPage } = props;
	return (
		<Flex w="100%" className={styles.root} gap="sm" px="lg" align="center" justify="flex-start">
			{forPage === TopNavFor.ACCOUNT && (
				<>
					<HeaderNavItem to="/account" label="My Profile" icon={IconUser} />
					<HeaderNavItem to="/billing" label="Billing" icon={IconWallet} />
					<HeaderNavItem to="/alerts" label="Alerts" icon={IconBell} />
				</>
			)}
			{forPage === TopNavFor.ENTRIES_AND_REWARDS && (
				<>
					<HeaderNavItem to="/rewards" label="My Entries" icon={IconTrophy} />
					<HeaderNavItem to="/past-winners" label="Past Winners" icon={IconStar} />
				</>
			)}
		</Flex>
	);
};
